"use client";

import { RadioGroup } from "@headlessui/react";

import { SmallTitle } from "@/components/text/SmallTitle";
import { cn } from "@/utils/cn";

export function MonthlyRadio({
  monthly,
  setMonthly,
}: {
  monthly: boolean;
  setMonthly: (isMonthly: boolean) => void;
}) {
  return (
    <RadioGroup
      value={monthly}
      onChange={setMonthly}
      className="relative grid grid-cols-2 gap-x-1 rounded-full p-1 text-center ring-1 ring-inset ring-gray-200"
    >
      <RadioGroup.Label className="sr-only">Payment frequency</RadioGroup.Label>

      <RadioGroup.Option
        value={true}
        className={({ checked }) =>
          cn(
            checked ? "bg-primary text-white" : "text-gray-900",
            "cursor-pointer rounded-full px-2.5 py-1"
          )
        }
      >
        <SmallTitle elementType="span" className="text-inherit">
          Monthly
        </SmallTitle>
      </RadioGroup.Option>

      <RadioGroup.Option
        value={false}
        className={({ checked }) =>
          cn(
            checked ? "bg-primary text-white" : "text-gray-900",
            "cursor-pointer rounded-full px-2.5 py-1"
          )
        }
      >
        <SmallTitle elementType="span" className="text-inherit">
          Yearly
        </SmallTitle>
      </RadioGroup.Option>
      <div className="pointer-events-none absolute -right-5 -top-4 z-10">
        <span className="rounded-md bg-gray-900 bg-opacity-80 px-2 py-1 text-xs font-medium text-white">
          -25%
        </span>
      </div>
    </RadioGroup>
  );
}
